import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
import PemantauanPacuSvc from "@/services/PemantauanPacuService";

@Module({
  store,
  dynamic: true,
  namespaced: true,
  name: "pemantauan-pacu",
})
class PemantauanPacuModule extends VuexModule {
  currentItem: any = null;
  loading = false;

  @Mutation SET_CURRENT_ITEM(val: any) {
    this.currentItem = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);
    try {
      const dt = await PemantauanPacuSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_CURRENT_ITEM(data || null);
    } catch {
      this.SET_CURRENT_ITEM(null);
    }
    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_CURRENT_ITEM(null);
  }
}

export const storePemantauanPacu = getModule(PemantauanPacuModule);
